import { render, staticRenderFns } from "./ExportAccordTemp.vue?vue&type=template&id=2b27192c&scoped=true"
import script from "./ExportAccordTemp.vue?vue&type=script&lang=js"
export * from "./ExportAccordTemp.vue?vue&type=script&lang=js"
import style0 from "./ExportAccordTemp.vue?vue&type=style&index=0&id=2b27192c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b27192c",
  null
  
)

export default component.exports